import { Delete, Get, Post, Put } from 'api/core/actions';
import type { TagDraft } from 'redux/modules/tags.types';
import type { Tag } from 'types/tag';
import type { TagBulkOperation } from 'utils/tagBulk';

export interface BulkTagsResult {
  succeeded_ids: number[];
  affected_ids: number[];
  affected_project_ids: number[];
  failed: { id: number; message: string }[];
}

import { encodeUrlParams } from 'utils/url-params';

export interface GetTagOptions {
  filter?: 'active' | 'all' | 'archived';
  page?: number;
  perPage?: number;
}

export const tagsApi = {
  bulk: (operation: TagBulkOperation, ids: number[], parentId?: number): Promise<BulkTagsResult> =>
    Put('labels/bulk', { operation, ids, ...(parentId != null ? { parent_id: parentId } : {}) }),
  getAll: ({
    filter = 'all',
    perPage = 1000,
    page = 1,
  }: GetTagOptions = {}): Promise<Array<Tag>> => {
    const params = {
      filter,
      limit: perPage,
      offset: (page - 1) * perPage,
    };
    return Get(`labels.json${encodeUrlParams(params)}`, {});
  },

  get: (id: number): Promise<Tag> => {
    return Get(`labels/${id}.json`);
  },

  save: (label: TagDraft): Promise<Tag> => {
    const labelId = label.id;
    if (labelId) {
      return Put(`labels/${labelId}`, { label }, {});
    }
    return Post('labels', { label }, {});
  },

  delete(id: number): Promise<unknown> {
    return Delete(`labels/${id}`, {}, {});
  },
};
